import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { asList2ho2pewtsfvv as asList } from './_ArraysJs.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import {
  filterNotNullhujglslymx1l as filterNotNull,
  contains1tccixv8iwdcq as contains,
} from './_Arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
} from '../exceptions.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../js/arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function collectionToArrayCommonImpl(collection) {
  if (collection.i1()) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.arrayOfNulls' call
  var size = collection.p1();
  var destination = Array(size);
  var iterator = collection.m1();
  var index = 0;
  while (iterator.n1()) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    destination[_unary__edvuaz] = iterator.o1();
  }
  return destination;
}
function listOf_0(elements) {
  return elements.length > 0 ? asList(elements) : emptyList();
}
function get_indices(_this__u8e3s4) {
  return numberRangeToNumber(0, _this__u8e3s4.p1() - 1 | 0);
}
function get_lastIndex(_this__u8e3s4) {
  return _this__u8e3s4.p1() - 1 | 0;
}
function listOfNotNull(elements) {
  return filterNotNull(elements);
}
function arrayListOf(elements) {
  var tmp;
  if (elements.length === 0) {
    tmp = ArrayList().w();
  } else {
    // Inline function 'kotlin.collections.asArrayList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ArrayList().s5(elements);
  }
  return tmp;
}
function listOfNotNull_0(element) {
  return !(element == null) ? listOf(element) : emptyList();
}
function emptyList() {
  return EmptyList_instance;
}
function mutableListOf(elements) {
  var tmp;
  if (elements.length === 0) {
    tmp = ArrayList().w();
  } else {
    // Inline function 'kotlin.collections.asArrayList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ArrayList().s5(elements);
  }
  return tmp;
}
var EmptyListClass;
function EmptyList() {
  if (EmptyListClass === VOID) {
    class $ {
      constructor() {
        this.el_1 = -7390468764508069838n;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtList()) : false) {
          tmp = other.i1();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 1;
      }
      toString() {
        return '[]';
      }
      p1() {
        return 0;
      }
      i1() {
        return true;
      }
      fl(element) {
        return false;
      }
      t1(element) {
        if (!false)
          return false;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.fl(tmp);
      }
      gl(elements) {
        return elements.i1();
      }
      l3(elements) {
        return this.gl(elements);
      }
      q1(index) {
        throw IndexOutOfBoundsException().je("Empty list doesn't contain element at index " + index + '.');
      }
      hl(element) {
        return -1;
      }
      s1(element) {
        if (!false)
          return -1;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.hl(tmp);
      }
      m1() {
        return EmptyIterator_instance;
      }
      u1(index) {
        if (!(index === 0))
          throw IndexOutOfBoundsException().je('Index: ' + index);
        return EmptyIterator_instance;
      }
      m3(fromIndex, toIndex) {
        if (fromIndex === 0 && toIndex === 0)
          return this;
        throw IndexOutOfBoundsException().je('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
      }
    }
    initMetadataForObject($, 'EmptyList', VOID, VOID, [KtList(), RandomAccess()]);
    EmptyListClass = $;
  }
  return EmptyListClass;
}
var EmptyList_instance;
function EmptyList_getInstance() {
  return EmptyList_instance;
}
function optimizeReadOnlyList(_this__u8e3s4) {
  switch (_this__u8e3s4.p1()) {
    case 0:
      return emptyList();
    case 1:
      return listOf(_this__u8e3s4.q1(0));
    default:
      return _this__u8e3s4;
  }
}
function binarySearch(_this__u8e3s4, fromIndex, toIndex, comparison) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.p1() : toIndex;
  rangeCheck(_this__u8e3s4.p1(), fromIndex, toIndex);
  var low = fromIndex;
  var high = toIndex - 1 | 0;
  while (low <= high) {
    var mid = (low + high | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4.q1(mid);
    var cmp = comparison(midVal);
    if (cmp < 0)
      low = mid + 1 | 0;
    else if (cmp > 0)
      high = mid - 1 | 0;
    else
      return mid;
  }
  return -(low + 1 | 0) | 0;
}
var EmptyIteratorClass;
function EmptyIterator() {
  if (EmptyIteratorClass === VOID) {
    class $ {
      n1() {
        return false;
      }
      v6() {
        return false;
      }
      w6() {
        return 0;
      }
      y6() {
        return -1;
      }
      o1() {
        throw NoSuchElementException().y1();
      }
      x6() {
        throw NoSuchElementException().y1();
      }
    }
    initMetadataForObject($, 'EmptyIterator');
    EmptyIteratorClass = $;
  }
  return EmptyIteratorClass;
}
var EmptyIterator_instance;
function EmptyIterator_getInstance() {
  return EmptyIterator_instance;
}
function rangeCheck(size, fromIndex, toIndex) {
  if (fromIndex > toIndex)
    throw IllegalArgumentException().a1('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
  else if (fromIndex < 0)
    throw IndexOutOfBoundsException().je('fromIndex (' + fromIndex + ') is less than zero.');
  else if (toIndex > size)
    throw IndexOutOfBoundsException().je('toIndex (' + toIndex + ') is greater than size (' + size + ').');
}
function throwIndexOverflow() {
  throw ArithmeticException().oe('Index overflow has happened.');
}
function throwCountOverflow() {
  throw ArithmeticException().oe('Count overflow has happened.');
}
function asCollection(_this__u8e3s4, isVarargs) {
  isVarargs = isVarargs === VOID ? false : isVarargs;
  return new (ArrayAsCollection())(_this__u8e3s4, isVarargs);
}
var ArrayAsCollectionClass;
function ArrayAsCollection() {
  if (ArrayAsCollectionClass === VOID) {
    class $ {
      constructor(values, isVarargs) {
        this.il_1 = values;
        this.jl_1 = isVarargs;
      }
      p1() {
        return this.il_1.length;
      }
      i1() {
        // Inline function 'kotlin.collections.isEmpty' call
        return this.il_1.length === 0;
      }
      kl(element) {
        return contains(this.il_1, element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.kl((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        return arrayIterator(this.il_1);
      }
    }
    initMetadataForClass($, 'ArrayAsCollection', VOID, VOID, [Collection()]);
    ArrayAsCollectionClass = $;
  }
  return ArrayAsCollectionClass;
}
//region block: init
EmptyList_instance = new (EmptyList())();
EmptyIterator_instance = new (EmptyIterator())();
//endregion
//region block: exports
export {
  EmptyIterator_instance as EmptyIterator_instance23xvvm1c2fncv,
  EmptyList_instance as EmptyList_instance3p5ns2dcwtdtb,
  arrayListOf as arrayListOf1fz8nib0ncbow,
  asCollection as asCollection2jt8ak1h50iom,
  binarySearch as binarySearchyyczvdessj07,
  collectionToArrayCommonImpl as collectionToArrayCommonImplq0mfhcp9jn08,
  emptyList as emptyList1g2z5xcrvp2zy,
  get_indices as get_indices3txodfl5wuu5j,
  get_lastIndex as get_lastIndex1yw0x4k50k51w,
  listOfNotNull_0 as listOfNotNull1v4ggfackvuny,
  listOfNotNull as listOfNotNull2woi2boe01ub4,
  listOf_0 as listOf1jh22dvmctj1r,
  mutableListOf as mutableListOf6oorvk2mtdmp,
  optimizeReadOnlyList as optimizeReadOnlyList2kolyxeo5m6k3,
  throwCountOverflow as throwCountOverflow18of2v929seka,
  throwIndexOverflow as throwIndexOverflow28kwzhaoae5ib,
};
//endregion

//# sourceMappingURL=CollectionsKt.mjs.map
